import { render, staticRenderFns } from "./CalendarBar.vue?vue&type=template&id=b2f0417c&scoped=true&"
import script from "./CalendarBar.vue?vue&type=script&lang=js&"
export * from "./CalendarBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f0417c",
  null
  
)

export default component.exports